//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppContainer',
  props: {
    'bodyPaddingTop': {
      type: String
    },
    'bodyPaddingBottom': {
      type: String
    }
  },
  data() {
    return {}
  },
  methods: {
    refresh() {
      location.reload()
    },
    scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top
    },
    getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop
    },
    getScrollBody() {
      return this.$refs.viewBoxBody
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AppContainer.vue